
import SetColor from '../setColor/index.jsx'
import Slider from '../slider/index.jsx'
import './side.less'
import { Input } from 'antd'
import React from 'react'
console.log(React)
export default function ConversionOfficialSide(props) {
  return (<div className={`conversionOfficialSide ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>

    <h3 className='conversionOfficialSide_title'>按钮</h3>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>网页链接</span>
      <div className='item_main'>
        <div className='item'>
          <Input placeholder='http://' value={props.ifon.link} onChange={(e) => {
            props.ifon.link = e.target.value
            props.mySetIfon(props.ifon)
          }}></Input>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>按钮文案</span>
      <div className='item_main'>
        <div className='item'>
          <Input placeholder='继续阅读下一章' maxLength={20} value={props.ifon.text} onChange={(e) => {
            props.ifon.text = e.target.value
            props.mySetIfon(props.ifon)
          }}></Input>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>按钮文案</span>
      <div className='Box'>
        <div className='item'>
          <span className='item_title'>文字</span>
          <SetColor color={props.ifon.color} setColor={(obj) => {
            props.ifon.color = obj.hex
            props.mySetIfon(props.ifon)
          }}></SetColor>
        </div>

        <div className='item'>
          <span className='item_title'>背景</span>
          <SetColor color={props.ifon.colorBack} setColor={(obj) => {
            props.ifon.colorBack = obj.hex
            props.mySetIfon(props.ifon)
          }}></SetColor>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>字号</span>
      <div className='item_main'>
        <div className='item'>
          <Slider minValue={16} maxValue={22} defaultValue={props.ifon.fontSize} change={(value) => {
            props.ifon.fontSize = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>尺寸</span>
      <div className='item_main'>
        <div className='item'>
          <Slider minValue={20} defaultValue={props.ifon.width} change={(value) => {
            props.ifon.width = value
            props.mySetIfon(props.ifon)
          }}>宽度</Slider>
        </div>
        <div className='item'>
          <Slider minValue={30} maxValue={60} defaultValue={props.ifon.height} change={(value) => {
            props.ifon.height = value
            props.mySetIfon(props.ifon)
          }}>高度</Slider>
        </div>
        <div className='item'>
          <Slider maxValue={30} defaultValue={props.ifon.fillet} change={(value) => {
            props.ifon.fillet = value
            props.mySetIfon(props.ifon)
          }}>圆角</Slider>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>布局</span>
      <div className='Box' onClick={(e) => {
        const text = e.target.dataset.index
        if (text) {
          props.ifon.layout = parseFloat(text)
          props.mySetIfon(props.ifon)
        }
      }}>
        <li className={`button ${props.ifon.layout === 0 ? 'active' : ''}`} data-index={0}>居左</li>
        <li className={`button ${props.ifon.layout === 1 ? 'active' : ''}`} data-index={1}>居中</li>
        <li className={`button ${props.ifon.layout === 2 ? 'active' : ''}`} data-index={2}>居右</li>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>边距</span>
      <div className='item_main'>
        <div className='item'>
          <Slider maxValue={50} defaultValue={props.ifon.paddingTop} change={(value) => {
            props.ifon.paddingTop = value
            props.mySetIfon(props.ifon)
          }}>上</Slider>
        </div>
        <div className='item'>
          <Slider maxValue={50} defaultValue={props.ifon.paddingBottom} change={(value) => {
            props.ifon.paddingBottom = value
            props.mySetIfon(props.ifon)
          }}>下</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingLeft} change={(value) => {
            props.ifon.paddingLeft = value
            props.mySetIfon(props.ifon)
          }}>左</Slider>
        </div>
        <div className='item'>
          <Slider defaultValue={props.ifon.paddingRight} change={(value) => {
            props.ifon.paddingRight = value
            props.mySetIfon(props.ifon)
          }}>右</Slider>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>固定悬浮</span>
      <div className='item_main'>
        <div className={`switch ${props.ifon.isSuspension ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.isSuspension = !props.ifon.isSuspension
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>与底部距离</span>
      <div className='item_main'>
        <div className='item'>
          <Slider defaultValue={props.ifon.bottomDistance} change={(value) => {
            props.ifon.bottomDistance = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>

    <div className='conversionOfficialSide_item'>
      <span className='item_title'>页尾留白</span>
      <div className='item_main'>
        <div className='item'>
          <Slider defaultValue={props.ifon.message} change={(value) => {
            props.ifon.message = value
            props.mySetIfon(props.ifon)
          }}></Slider>
        </div>
      </div>
    </div>
  </div>)
}
